import { render, staticRenderFns } from "./RedirectUploadForm.vue?vue&type=template&id=e48bd048&"
import script from "./RedirectUploadForm.vue?vue&type=script&lang=js&"
export * from "./RedirectUploadForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports